import { Component, OnInit, OnDestroy, Input, ViewChild, TemplateRef } from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';

import { AccountService } from 'app/account/account.service';
import { BaseService } from 'app/_services/base.service';
import { BuyerDashboardService } from './dashboard.service';
import { BuyerService } from '../_services/buyer.service';
import { BuyerSignalRService } from '../_services/buyer.signalr.service';
import { PartsfyNotificationService } from 'app/general/_services/partsfy-notification.service';
import { NotificationService } from 'app/_services/notification.service';
import { SettingsService } from 'app/_services/settings.service';
import { UserService } from 'app/_services/user.service';

import { BuyerDadosConvitesComponent } from '../_componentes/dados-convite/dados-convite.component';
import { BuyerDashboardModalAvaliacaoComponent } from './_components/modal-avaliacao/modal-avaliacao.component';

import { CancelReasons } from 'app/_models/cancelReasons';
import { Globals } from 'app/_models/globals';
import { NotificationQuotation } from 'app/_models/notificationQuotation';
import { StatusIdEnum } from 'app/_models/statusId';
import { ApiResponseModel } from 'app/_models/apiResponseModel';

declare const $: any;
declare const compararStringContemString: any;
declare const deepSetObj: any;
declare const findInArrayTwoProperties: any;
declare const formatDateToDDMMYYYYHHMM: any;
declare const isEmpty: any;
declare const getJavascriptDateFromCSharpDate: any;
declare const getJavascriptDateFromIsoDate: any;
declare const replaceAll: any;
declare const sort_by: any;

@Component({
    selector: 'app-dashboard', templateUrl: './dashboard.component.html', styleUrls: ['./dashboard.component.scss'],
    standalone: false
})

export class BuyerDashboardComponent implements OnInit, OnDestroy {
    @Input() id: string;
    @ViewChild('dadosConviteComponent') dadosConviteComponent: BuyerDadosConvitesComponent;
    @ViewChild('modalAvaliacaoComponent') modalAvaliacaoComponent: BuyerDashboardModalAvaliacaoComponent

    @ViewChild('templateEnviarConvite') templateEnviarConvite: TemplateRef<any>;
    @ViewChild('templateExcluirCotacao') templateExcluirCotacao: TemplateRef<any>;
    modalRef: BsModalRef;
    conviteNotifier: Subject<boolean> = new Subject<boolean>();

    comment: string = '';
    selected_reason: any;

    isUsuarioLocalPlanoPopular: boolean;
    private _searchTerm: string;
    avaliacoes = [];
    loading: any;
    quotations = [];
    filteredQuotations = [];

    column01Quotations = [];
    column02Quotations = [];
    column03Quotations = [];
    column04Quotations = [];
    excluirCotacaoReasons: CancelReasons[] = [];
    idCotacaoSelecionada: number;
    origem_tipo: string;

    currentNotificationList: NotificationQuotation[];
    notificationListUnreadMessages: number = 0;

    private subscriptionMsgsListaNaoLidas;
    private subscriptionNotificationList;
    private subscriptionAtualizarDashboardCompradorEvent: Subscription;

    vehicleCotacaoSelecionada: string;
    timeLeft: number = 60;
    interval;

    excluirCotacaoNeedsComment: boolean = false;

    constructor(public accountService: AccountService, public userService: UserService, private baseService: BaseService, private buyerDashboardService: BuyerDashboardService, private buyerService : BuyerService,
        private buyerSignalRService: BuyerSignalRService, public partsfyNotificationService: PartsfyNotificationService, private notificationService: NotificationService,
        private settingsService: SettingsService, private globals: Globals, private modalService: BsModalService, private ngxLoader: NgxUiLoaderService, private router: Router)
    {
        this.loading = { removeQuotation: false };
        this.origem_tipo = window.location.href.toString().includes('gestor-comprador') ? 'gestor-comprador' : (window.location.href.toString().includes('supervisor-comprador') ? 'supervisor-comprador' : 'comprador');
    }

    ngOnInit() {
        this.isUsuarioLocalPlanoPopular = this.userService.userPlan() === 1;

        this.registerObservables();

        this.subscriptionMsgsListaNaoLidas = this.partsfyNotificationService.totalMensagensNaoLidas.subscribe(tm =>
        {
            this.notificationListUnreadMessages = tm;
        });

        this.subscriptionNotificationList = this.partsfyNotificationService.notificationList.subscribe(nl =>
        {
            this.currentNotificationList = nl;

            if (!isEmpty(this.currentNotificationList))
            {
                let totalmsgsnaolidas = this.currentNotificationList.filter(n => n.status_id === 0).length;
                this.partsfyNotificationService.atualizarTotalMsgsNaoLidas();
                this.notificationListUnreadMessages = totalmsgsnaolidas;
            }
        });

        this.carregarTela();
    }

    ngOnDestroy()
    {
        this.subscriptionMsgsListaNaoLidas.unsubscribe();
        this.subscriptionNotificationList.unsubscribe();
        this.subscriptionAtualizarDashboardCompradorEvent.unsubscribe();
    }

    atualizarCotacaoDistribuida(cotacaoDistribuida)
    {
        var cotacao = findInArrayTwoProperties(this.quotations, 'transaction_id', cotacaoDistribuida.transaction_id, 'coluna', 0);

        if (isEmpty(cotacao))
            return;

        cotacao.tem_resposta = cotacaoDistribuida.tem_resposta;
        cotacao.tem_vendedor = cotacaoDistribuida.tem_vendedor;
    }

    atualizarDadosCotacao(cotacao) {
        if (cotacao.coluna === 0)
        {
            cotacao.update_date_js = getJavascriptDateFromCSharpDate(cotacao.update_date);

            if (cotacao.comentarios && cotacao.comentarios.length > 0) {
                cotacao.comentarios = cotacao.comentarios.map(c => {
                    c.data = formatDateToDDMMYYYYHHMM(new Date(c.data + 'Z'))
                    return c;
                })
            }
        }
        else if (cotacao.coluna >= 1) {
            cotacao.closest_delivery_date_js = getJavascriptDateFromCSharpDate(cotacao.closest_delivery_date);

            let statusEntrega = this.statusEntrega(cotacao.closest_delivery_date_js, cotacao.coluna, cotacao.com_nota_sem_inconsistencia, cotacao.min_status_id, cotacao.max_status_id);
            cotacao.classe = statusEntrega.classe;
            cotacao.status_entrega = statusEntrega.status;
            cotacao.order = statusEntrega.order != null ? statusEntrega.order : 99;
        }
    }

    carregarTela() {
        this.ngxLoader.startLoader('loader-principal');
        this.getAllQuotations(0);
    }

    compararColuna(coluna1, coluna2)
    {
        if (coluna1 === 0 || coluna1 === 3)
            return coluna1 === coluna2;

        return coluna2 === 1 || coluna2 === 2;
    }

    enviarConviteAbrirModal()
    {
        let options: ModalOptions = { backdrop: 'static', class: 'gray modal-lg', keyboard: false };
        this.modalRef = this.modalService.show(this.templateEnviarConvite, options);
    }

    enviarConviteFecharModal()
    {
        this.modalRef.hide();
    }

    enviarConviteFormInvalid()
    {
        return $($('.form-convite')[0]).attr('class').indexOf('ng-invalid') > -1;
    }

    enviarConvite()
    {
        this.conviteNotifier.next(true);
        this.modalRef.hide();
    }

    excluirCotacaoAbrirModal(idCotacaoSelecionada)
    {
        setTimeout(() =>
        {
            $('textarea[name="comment"]').val('');
            this.excluirCotacaoNeedsComment = false;
            $('select[name="reason"]')[0].selectedIndex = 0;
        }, 200);

        this.idCotacaoSelecionada = idCotacaoSelecionada;
        var cotacao = findInArrayTwoProperties(this.quotations, 'transaction_id', idCotacaoSelecionada, 'coluna', 0);
        this.vehicleCotacaoSelecionada = cotacao.vehicle;

        let options: ModalOptions = { backdrop: 'static', class: 'gray modal-lg', keyboard: false };
        this.modalRef = this.modalService.show(this.templateExcluirCotacao, options);
    }

    excluirCotacaoFecharModal()
    {
        this.modalRef.hide();
    }

    excluirCotacaoChangeValue() {
        var needsComment = $('select[name="reason"]').find(':selected').attr('needs-comment') == 'true';
        $('textarea[name="comment"]').val('');

        this.excluirCotacaoNeedsComment = needsComment;
    }

    async excluirCotacao(nAttempts: number) {
        this.loading.removeQuotation = true;

        var reason_id = parseInt($('select[name="reason"]').val());
        var selected_quotation_id = this.idCotacaoSelecionada;
        var comment = $('textarea[name="comment"]').val();

        if (this.excluirCotacaoNeedsComment && isEmpty(comment.trim())) {
            await this.notificationService.showWarning('buyer.visao-geral.mensagens.erro.excluir-cotacao.comment-obrigatorio.corpo', 'buyer.visao-geral.mensagens.erro.excluir-cotacao.comment-obrigatorio.titulo');
            this.loading.removeQuotation = false;
            return;
        }

        this.ngxLoader.startLoader('loader-principal');

        this.buyerDashboardService.deleteQuotation(selected_quotation_id, reason_id, comment).subscribe({
            next: (res: ApiResponseModel<boolean>) => {
                this.ngxLoader.stopLoader('loader-principal');
                this.loading.removeQuotation = false;

                if (res && res.success && res.result) {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.visao-geral.mensagens.sucesso.excluir-cotacao'));
                    this.excluirCotacaoFecharModal();

                    this.getAllQuotations(0);

                    if (reason_id == 1) {
                        this.enviarConviteAbrirModal();
                    }

                    return;
                }

                this.notificationService.showErrorToastr(this.globals.translate('buyer.visao-geral.mensagens.erro.excluir-cotacao.excluir'));
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.ngxLoader.stopLoader('loader-principal');
                    this.loading.removeQuotation = false;
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.visao-geral.mensagens.erro.excluir-cotacao.gravacao.corpo'));
                    return;
                }

                this.excluirCotacao(++nAttempts);
            }
        });
    }

    execLoader(nomeLoader, is_start)
    {
        try
        {
            if (is_start)
                this.ngxLoader.stopLoader(nomeLoader);
            else
                this.ngxLoader.stopLoader(nomeLoader);
        }
        catch (e) { console.log(e); }
    }

    filterQuotations(searchString: string)
    {
        if (!searchString || !this.quotations)
            return this.quotations;

        var term: string = replaceAll(searchString.toLowerCase() , '-', '');

        var result = this.quotations.filter(quotation =>
        {
            const vehicle = quotation.vehicle.toLowerCase();
            const licensePlate = vehicle.substring(vehicle.lastIndexOf('(') + 1, vehicle.lastIndexOf(')')).replace(' ', '').replace('-', '');

            return quotation.quotation_id.toString().indexOf(term) !== -1 ||
                quotation.other_order_ids.some(c => c.toString().indexOf(term) > -1) ||
                (quotation.status_entrega && quotation.status_entrega.toLowerCase().indexOf(term) !== -1) ||
                (!isEmpty(quotation.vehicle) && (compararStringContemString(vehicle, term) || compararStringContemString(licensePlate, replaceAll(term, ' ', '')))) ||
                compararStringContemString(quotation.brand_name, term)
        });

        return result;
    }

    getAllQuotations(nAttempts, includeReviews = true)
    {
        this.buyerDashboardService.getAllQuotations(includeReviews).subscribe({
            next: async (response: ApiResponseModel<{ list, reasons, reviews }>) => {
                if (response && response.success) {
                    let quotations = response.result.list.cotacoes;
                    quotations.forEach(cotacao => { this.atualizarDadosCotacao(cotacao); });

                    this.quotations = quotations;
                    this.avaliacoes = response.result.reviews;

                    this.avaliacoes.forEach(avaliacao => { avaliacao.creation_date = getJavascriptDateFromIsoDate(avaliacao.creation_date) })

                    this.excluirCotacaoReasons = response.result.reasons;
                    this.updateFilteredQuotations();

                    if (!isEmpty(this.avaliacoes) && this.modalService.getModalsCount() === 0) {
                        this.avaliacoes.forEach(avaliacao => {
                            avaliacao.foi_bom = true
                        })

                        await this.modalAvaliacaoComponent.close();
                        await this.modalAvaliacaoComponent.open();
                    }
                }

                this.execLoader('loader-principal', false);
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.execLoader('loader-principal', false);
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.visao-geral.mensagens.erro.carregamento.corpo'));
                    return;
                }

                this.getAllQuotations(++nAttempts);
            }
        });
    }

    goToAvaliacoes()
    {
        this.router.navigate(['/' + this.origem_tipo + '/avaliacoes'], { queryParams: {} });
    }

    goToDetalhes(cotacao: any, tipo: number)
    {
        if (tipo == 1)
            this.router.navigate(['/' + this.origem_tipo + '/visao-geral/comprar/' + cotacao.transaction_id]);
        else
            this.router.navigate(['/' + this.origem_tipo + '/visao-geral/pedido/' + cotacao.transaction_id]);
    }

    goToHistorico()
    {
        this.router.navigate(['/' + this.origem_tipo + '/historico'], { queryParams: {} });
    }

    goToNovaCotacao()
    {
        this.router.navigate(['/comprador/visao-geral/nova-cotacao'], { queryParams: {} });
    }

    pedirAjuda(transaction_id)
    {
        var cotacao = findInArrayTwoProperties(this.quotations, 'transaction_id', transaction_id, 'coluna', 0);

        if (isEmpty(cotacao))
            return;

        if (this.isUsuarioLocalPlanoPopular) // Se for plano popular, abre o cta
        {
            this.buyerService.pedirAjudaPopularModal();
        }
        else // Se for outro plano, abre o motivo e volta para o cotador
        {
            this.buyerService.enviarCotacaoCotador((pediu_ajuda, motivo) =>
            {
                if (pediu_ajuda && !isEmpty(motivo))
                    this.pedirAjudaExecutar(transaction_id, cotacao, motivo, 0);
            });
        }
    }

    pedirAjudaExecutar(quotation_id: number, cotacao, motivo: string, nAttempts: number)
    {
        this.buyerService.enviarCotacaoCotadorExecutar(quotation_id, motivo, nAttempts,
            () => { cotacao.is_done_by_support = false; this.updateFilteredQuotations(); },
            null);
    }

    sortQuotations()
    {
        if (this.filteredQuotations === null || this.filteredQuotations === undefined)
            return;

        this.column01Quotations = this.filteredQuotations.filter(q => q.coluna === 0);
        this.column01Quotations.sort(sort_by([{ name: 'update_date_js', reverse: true }]));

        this.column02Quotations = this.filteredQuotations.filter(q => q.coluna === 1);
        this.column02Quotations.sort(sort_by([{ name: 'coluna', reverse: true }, { name: 'closest_delivery_date_js' }]));

        this.column03Quotations = this.filteredQuotations.filter(q => q.coluna === 2);
        this.column03Quotations.sort(sort_by([{ name: 'coluna', reverse: true }, { name: 'order' }, { name: 'closest_delivery_date_js' }]));

        this.column04Quotations = this.filteredQuotations.filter(q => q.coluna === 3);
        this.column04Quotations.sort(sort_by([{ name: 'closest_delivery_date_js' }]));
    }

    statusEntrega(deliveryDate, coluna, comNotaSemInconsistencia: boolean, statusId: number, maxStatusId: number): any {
        let localDeliveryDate = new Date(deliveryDate);

        if (coluna === 1) {
            if (maxStatusId <= 4) {
                switch (statusId) {
                    case StatusIdEnum.EmAnalise:
                        return { status: this.globals.translate('buyer.visao-geral.colunas.titulos.em-analise'), classe: "label-warning" };
                    case StatusIdEnum.Pedido:
                        return { status: this.globals.translate('buyer.visao-geral.colunas.titulos.confirmacao'), classe: "label-yellow" };
                    default:
                        return { status: '', classe: "" };
                }
            } else {
                switch (maxStatusId) {
                    case StatusIdEnum.AguardandoConfirmacaoDevolucao:
                        return { status: this.globals.translate('buyer.visao-geral.colunas.titulos.confirmacao-devolucao'), classe: "label-yellow" };
                    case StatusIdEnum.AguardandoConfirmacaoTroca:
                        return { status: this.globals.translate('buyer.visao-geral.colunas.titulos.confirmacao-troca'), classe: "label-yellow" };
                    default:
                        return { status: '', classe: "" };
                }
            }
        }
        if(localDeliveryDate == null)
            return { status: '', classe: "" };

        let today = new Date();
        let tomorrow = new Date(new Date().getTime() + (24 * 60 * 60 * 1000));
        const isDelayed = localDeliveryDate < today;

        localDeliveryDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        tomorrow.setHours(0, 0, 0, 0);

        if (isDelayed || comNotaSemInconsistencia) {
            const hasNFTitle = comNotaSemInconsistencia ? '-purple' : '';
            const hasNFText = comNotaSemInconsistencia ? { order: 2, status: 'despachado' } : { order: 1, status: 'atrasado' };
            return { order: hasNFText.order, status: this.globals.translate(`buyer.visao-geral.colunas.titulos.${hasNFText.status}`), classe: `label-danger${hasNFTitle}` };
        }

        if (localDeliveryDate.getTime() == today.getTime())
            return { status: this.globals.translate('buyer.visao-geral.colunas.titulos.entrega-hoje'), classe: "label-warning" };

        if (localDeliveryDate.getTime() == tomorrow.getTime())
            return { status: this.globals.translate('buyer.visao-geral.colunas.titulos.entrega-amanha'), classe: "label-warning" };

        if (localDeliveryDate.getTime() > tomorrow.getTime())
            return { status: this.globals.translate('buyer.visao-geral.colunas.titulos.aguardando-entrega'), classe: "label-success" };
    }

    updateFilteredQuotations()
    {
        var quotations = this.filterQuotations(this.searchTerm);

        this.filteredQuotations = quotations;
        this.sortQuotations();
    }

    whatsApp_abrir()
    {
        var url = this.settingsService.getWhatsAppWaMeSuporteUrl();
        window.open(url, '_blank');
    }

    get searchTerm(): string
    {
        return this._searchTerm;
    }

    set searchTerm(value: string)
    {
        this._searchTerm = value;
        this.filteredQuotations = this.filterQuotations(value);
        this.sortQuotations();
    }

    signalRAtualizarCotacao(cotacao)
    {
        if (this.buyerSignalRService.enableSignalRLog)
            console.log('BuyerDashboardComponent.signalRAtualizarCotacao', cotacao);

        let index = this.quotations.findIndex(q => q.quotation_id === cotacao.quotation_id);

        this.atualizarDadosCotacao(cotacao);

        if (isEmpty(index) || index < 0) {
            this.quotations.push(cotacao);
        } else
            deepSetObj(this.quotations[index], cotacao);

        this.updateFilteredQuotations();
    }

    signalRExcluirCotacao(cotacao)
    {
        let index = this.quotations.findIndex(q => q.quotation_id === cotacao.quotation_id);

        if (!isEmpty(index) && index >= 0)
        {
            this.quotations.splice(index, 1);
            this.updateFilteredQuotations();
        }
    }

    registerObservables() {
        let isSubscribed = this.buyerSignalRService.AtualizarDashboardCompradorEvent.observed;

        if (!isSubscribed) {
            this.subscriptionAtualizarDashboardCompradorEvent = this.buyerSignalRService.AtualizarDashboardCompradorEvent.subscribe(data => {
                if (this.buyerSignalRService.enableSignalRLog)
                    console.log('BuyerDashboardComponent.AtualizarDashboardCompradorEvent', data);

                if (!isEmpty(data)) {
                    let cotacao = JSON.parse(data);
                    this.signalRAtualizarCotacao(cotacao);
                } else {
                    this.getAllQuotations(0);
                }
            });
        }
    }
}
